 import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

 // Keys used by Anaya Collection for scroll/state restoration
 const ANAYA_SCROLL_RESTORE_KEY = 'anaya_collection_last_product';
 const ANAYA_SCROLL_RESTORE_Y_KEY = 'anaya_collection_scroll_y';
 const ANAYA_SEARCH_KEY = 'anaya_collection_search';
 const ANAYA_FILTERS_KEY = 'anaya_collection_filters';
 
const ScrollToTop = () => {
  const { pathname } = useLocation();

  // Use useLayoutEffect to scroll before paint, preventing any visible scroll animation
  useLayoutEffect(() => {
     // Skip scroll-to-top if we're navigating to collection with a pending scroll restoration
    if (
      pathname === '/anaya-collection' &&
      (sessionStorage.getItem(ANAYA_SCROLL_RESTORE_KEY) ||
        sessionStorage.getItem(ANAYA_SCROLL_RESTORE_Y_KEY) ||
        sessionStorage.getItem(ANAYA_SEARCH_KEY) ||
        sessionStorage.getItem(ANAYA_FILTERS_KEY))
    ) {
       return;
     }
     
    // Instant scroll to top with no animation
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
